/**
 * List Schema of BaseFretebasEmpresa
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {BaseFretebasEmpresa} from '@/model/resource/BaseFretebasEmpresa'

/* TODO: review generated schema */
export class ListBaseFretebasEmpresaSchema extends Schema {
  readonly name = 'ListBaseFretebasEmpresa'

  readonly fieldSet: FieldSet<BaseFretebasEmpresa> = {
    idFretebasPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    empresa: (): FieldComponent => ({
      is: Component.Render,
    }),
    razaoSocial: (): FieldComponent => ({
      is: Component.Render,
    }),
    ramo: (): FieldComponent => ({
      is: Component.Render,
    }),
    tipo: (): FieldComponent => ({
      is: Component.Render,
    }),
    endereco: (): FieldComponent => ({
      is: Component.Render,
    }),
    nextel: (): FieldComponent => ({
      is: Component.Render,
    }),
    celular: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.phone(schema.model.celular),
      },
    }),
    fone: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.phone(schema.model.fone),
      },
    }),
    whatsup: (): FieldComponent => ({
      is: Component.Render,
    }),
    sac: (): FieldComponent => ({
      is: Component.Render,
    }),
    response: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
